export default "__VITE_ASSET__COLFtxWm__"